import { render, staticRenderFns } from "./addOwner.vue?vue&type=template&id=f2984a9c&scoped=true&"
import script from "./addOwner.vue?vue&type=script&lang=js&"
export * from "./addOwner.vue?vue&type=script&lang=js&"
import style0 from "./addOwner.vue?vue&type=style&index=0&id=f2984a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2984a9c",
  null
  
)

export default component.exports